import { Sunrise, Sun, Sunset, Moon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night'

// Local hour buckets. Recomputed on every render (cheap) so a dashboard left open
// across a boundary refreshes on the next snapshot tick.
export function getTimeOfDay(date: Date = new Date()): TimeOfDay {
  const h = date.getHours()
  if (h < 5) return 'night'
  if (h < 12) return 'morning'
  if (h < 17) return 'afternoon'
  if (h < 21) return 'evening'
  return 'night'
}

export const GREETING: Record<TimeOfDay, { text: string; Icon: LucideIcon }> = {
  morning: { text: 'Good morning', Icon: Sunrise },
  afternoon: { text: 'Good afternoon', Icon: Sun },
  evening: { text: 'Good evening', Icon: Sunset },
  night: { text: 'Good evening', Icon: Moon },
}

// Flat-illustration landscape palette for GreetingBackdrop — a layered nature scene
// (sky, sun/moon, far mountains, rolling hills, firs) per period. Deliberately NOT
// theme tokens: a painted landscape isn't a UI surface. The panel lays a themed
// scrim over the lower half so card/text contrast always comes from the theme.
export type ScenePalette = {
  skyFrom: string
  skyMid?: string
  skyTo: string
  orb: string
  orbGlow: string
  hillFar: string
  hillMid: string
  hillNear: string
  tree: string
  star: string
}

export const SCENE: Record<TimeOfDay, ScenePalette> = {
  morning: {
    skyFrom: '#FFE1C4', skyTo: '#BFE1F2',
    orb: '#FFCB6B', orbGlow: '#FFE7BD',
    hillFar: '#AECFDA', hillMid: '#83B3C1', hillNear: '#52899A', tree: '#3F6E7B',
    star: '#FFFFFF',
  },
  afternoon: {
    skyFrom: '#79C2EF', skyTo: '#E1F2FC',
    orb: '#FFE07A', orbGlow: '#FFF3CC',
    hillFar: '#C3E5D5', hillMid: '#92CCB0', hillNear: '#5FA987', tree: '#4B8C6D',
    star: '#FFFFFF',
  },
  evening: {
    skyFrom: '#F9B26A', skyMid: '#E27A79', skyTo: '#7C4A8E',
    orb: '#FF7B54', orbGlow: '#FFC49A',
    hillFar: '#C77F9E', hillMid: '#95588A', hillNear: '#5C3A66', tree: '#452D50',
    star: '#FFE7CF',
  },
  night: {
    skyFrom: '#233268', skyTo: '#090D20',
    orb: '#ECEFFF', orbGlow: '#8E9AD6',
    hillFar: '#2B3B65', hillMid: '#1A2646', hillNear: '#0E1530', tree: '#0A1024',
    star: '#DCE3FF',
  },
}
